import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      nav: {
        inicio: "Inicio",
        portfolio: "Portfolio",
        servicios: "Servicios",
        planes: "Planes",
        blog: "Blog",
        contacto: "Contacto",
        agendarConsulta: "Agendar Consulta"
      },
      // Hero
      hero: {
        subtitle: "Firma Técnica de Paisaje Naturalista — Los Cabos",
        title: "Tu propiedad merece un paisaje que evolucione contigo",
        description: "No jardines decorativos. Diseñamos sistemas vivos estructurados, adaptados al microclima, al suelo y al uso real de cada propiedad en Los Cabos.",
        ctaPrimary: "Agendar Visita Inicial",
        ctaPrimaryNote: "$7,000 MXN — descontable si avanzas a proyecto",
        ctaSecondary: "Ver Portfolio"
      },
      // Philosophy - Live Outside
      philosophy: {
        subtitle: "Nuestra Filosofía",
        title: "Live Outside",
        paragraph: "Invertir en el exterior es invertir en calidad de vida. Habitar el jardín con plantas, agua y materiales nobles. Vivir el sol y la sombra, las aves, las flores. El desierto tropical de Los Cabos ofrece el escenario perfecto para quien entiende que afuera también se vive.",
        quote: "\"Un jardín es una cooperación con la naturaleza: la editamos sin someterla, la guiamos sin forzarla. El verdadero paisaje no se impone — se cultiva con paciencia y se hereda con orgullo.\"",
        quoteAuthor: "— Russell Page, The Education of a Gardener"
      },
      // Services
      services: {
        subtitle: "Nuestros Servicios",
        title: "Tres líneas de servicio",
        viewAll: "Ver todos los servicios",
        learnMore: "Conocer más",
        service1: {
          title: "Diseño Naturalista Integral",
          description: "Estudio técnico completo con plan maestro evolutivo. Diseño adaptado al microclima de Los Cabos."
        },
        service2: {
          title: "Proyectos Estratégicos",
          description: "Intervenciones de alto impacto para desarrolladores. Cronograma claro, ejecución eficiente."
        },
        service3: {
          title: "Cuidado Ecosistémico",
          description: "Mantenimiento técnico con visión a largo plazo. Ajustes evolutivos, conservación del diseño y orden riguroso."
        }
      },
      // Portfolio
      portfolio: {
        subtitle: "Portfolio",
        title: "Proyectos destacados",
        viewAll: "Ver portfolio completo",
        viewProject: "Ver proyecto",
        noProjects: "Próximamente: proyectos en desarrollo"
      },
      // CTA
      cta: {
        title: "Tu espacio exterior puede estar en otro nivel",
        description: "Sin improvisar. Sin errores técnicos. Comenzamos con una visita inicial para evaluar tu propiedad con criterio técnico.",
        button: "Agendar Visita Inicial",
        buttonNote: "Descontable si avanzas a proyecto"
      },
      // Testimonial/Quote
      testimonial: {
        quote: "Estructuramos paisajes que funcionan en el clima real de Los Cabos. No vendemos plantas — vendemos criterio, integración y coherencia."
      },
      // Stats
      stats: {
        projects: "Proyectos completados",
        years: "Años de experiencia",
        native: "Vegetación nativa",
        location: "Baja California Sur"
      },
      // Texture break
      texture: {
        headline: "No jardines decorativos. Paisajes con intención técnica.",
        paragraph: "Cada proyecto comienza con un estudio técnico del microclima, suelo y drenaje. Diseñamos sistemas vivos que evolucionan con el tiempo, adaptados a las condiciones únicas de Baja California Sur.",
        cta: "Conoce nuestro proceso"
      },
      // Marquee
      marquee: {
        items: "Diseño Naturalista / Proyectos Estratégicos / Cuidado Ecosistémico / Los Cabos"
      },
      // Footer
      footer: {
        description: "Firma técnica de paisaje naturalista. Diseñamos paisajes adaptados al microclima, al suelo y al uso real de cada propiedad.",
        liveOutside: "Live Outside",
        navigation: "Navegación",
        services: "Servicios",
        contact: "Contacto",
        rights: "Todos los derechos reservados."
      },
      // Contact page
      contact: {
        subtitle: "Contacto",
        title: "Hablemos de tu proyecto",
        description: "Comenzamos con una visita inicial para conocer tu propiedad. El costo de la visita se descuenta si avanzas a proyecto o plan de mantenimiento.",
        visitaInicial: "Visita Inicial",
        visitaDescription: "Incluye recorrido de la propiedad, análisis preliminar y propuesta de alcance.",
        descontable: "Descontable de proyecto",
        form: {
          title: "Solicita información",
          name: "Nombre completo",
          email: "Email",
          phone: "Teléfono",
          location: "Ubicación de la propiedad",
          serviceType: "Tipo de servicio",
          propertyType: "Tipo de propiedad",
          message: "Mensaje / Detalles del proyecto",
          submit: "Enviar mensaje",
          sending: "Enviando..."
        }
      },
      // Plans
      plans: {
        subtitle: "Planes y Precios",
        title: "Elige tu plan",
        description: "El costo de la visita inicial se descuenta si avanzas a proyecto o plan de mantenimiento.",
        recommended: "Recomendado",
        selectPlan: "Seleccionar plan",
        monthly: "mensual",
        unique: "único",
        howItWorks: "¿Cómo funciona el modelo?",
        modelDescription1: "Comenzamos con una Visita Inicial para evaluar tu propiedad. Este recorrido incluye análisis preliminar del sitio y propuesta de alcance.",
        modelDescription2: "Si decides avanzar con un proyecto o plan de mantenimiento, el costo de la visita se descuenta del primer pago.",
        plan1: {
          name: "Mantenimiento Básico",
          description: "Cuidado esencial para jardines residenciales"
        },
        plan2: {
          name: "Mantenimiento Premium",
          description: "Cuidado integral con asesoría técnica incluida"
        },
        plan3: {
          name: "Visita Inicial",
          description: "Evaluación de tu propiedad — descontable de proyectos"
        }
      },
      // Blog
      blog: {
        subtitle: "Conocimiento",
        title: "Blog",
        description: "Artículos sobre paisajismo, selección vegetal y diseño exterior en el clima de Los Cabos.",
        readMore: "Leer más"
      },
      // Servicios page
      serviciosPage: {
        subtitle: "Nuestros Servicios",
        title: "Tres líneas de servicio técnico",
        description: "Cada línea responde a necesidades específicas: desde el propietario que busca integración a largo plazo, hasta el desarrollador que prioriza ejecución eficiente.",
        requestInfo: "Solicitar información",
        process: {
          title: "Proceso Círculo",
          description: "Nuestro proceso garantiza resultados duraderos.",
          step1: { title: "Diagnóstico", description: "Visita y análisis del sitio" },
          step2: { title: "Diseño", description: "Plan maestro naturalista" },
          step3: { title: "Ejecución", description: "Implementación por fases" },
          step4: { title: "Evolución", description: "Seguimiento continuo" }
        },
        ctaTitle: "¿Cuál es tu necesidad?",
        ctaDescription: "Comienza con una visita inicial. El costo se descuenta si avanzas a proyecto o mantenimiento."
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        inicio: "Home",
        portfolio: "Portfolio",
        servicios: "Services",
        planes: "Plans",
        blog: "Blog",
        contacto: "Contact",
        agendarConsulta: "Book Consultation"
      },
      // Hero
      hero: {
        subtitle: "Naturalist Landscape Firm — Los Cabos",
        title: "Your property deserves a landscape that evolves with you",
        description: "Not decorative gardens. We design structured living systems, adapted to the microclimate, soil, and real use of each property in Los Cabos.",
        ctaPrimary: "Book Initial Visit",
        ctaPrimaryNote: "$7,000 MXN — deductible if you proceed to project",
        ctaSecondary: "View Portfolio"
      },
      // Philosophy - Live Outside
      philosophy: {
        subtitle: "Our Philosophy",
        title: "Live Outside",
        paragraph: "Investing in your outdoor space is investing in quality of life. Inhabiting the garden with plants, water, and noble materials. Living the sun and shade, the birds, the flowers. The tropical desert of Los Cabos offers the perfect setting for those who understand that life happens outside too.",
        quote: "\"A garden is a cooperation with nature: we edit it without subduing it, we guide it without forcing it. A true landscape is not imposed — it is cultivated with patience and inherited with pride.\"",
        quoteAuthor: "— Russell Page, The Education of a Gardener"
      },
      // Services
      services: {
        subtitle: "Our Services",
        title: "Three service lines",
        viewAll: "View all services",
        learnMore: "Learn more",
        service1: {
          title: "Integral Naturalist Design",
          description: "Complete technical study with evolutionary master plan. Design adapted to the Los Cabos microclimate."
        },
        service2: {
          title: "Strategic Projects",
          description: "High-impact interventions for developers. Clear timeline, efficient execution."
        },
        service3: {
          title: "Ecosystemic Care",
          description: "Technical maintenance with long-term vision. Evolutionary adjustments, design conservation, and rigorous upkeep."
        }
      },
      // Portfolio
      portfolio: {
        subtitle: "Portfolio",
        title: "Featured projects",
        viewAll: "View full portfolio",
        viewProject: "View project",
        noProjects: "Coming soon: projects in development"
      },
      // CTA
      cta: {
        title: "Your outdoor space can be on another level",
        description: "No improvising. No technical mistakes. We start with an initial visit to evaluate your property with technical criteria.",
        button: "Book Initial Visit",
        buttonNote: "Deductible if you proceed to project"
      },
      // Testimonial/Quote
      testimonial: {
        quote: "We structure landscapes that work in the real climate of Los Cabos. We don't sell plants — we sell criteria, integration, and coherence."
      },
      // Stats
      stats: {
        projects: "Projects completed",
        years: "Years of experience",
        native: "Native vegetation",
        location: "Baja California Sur"
      },
      // Texture break
      texture: {
        headline: "Not decorative gardens. Landscapes with technical intention.",
        paragraph: "Each project begins with a technical study of the microclimate, soil, and drainage. We design living systems that evolve over time, adapted to the unique conditions of Baja California Sur.",
        cta: "Discover our process"
      },
      // Marquee
      marquee: {
        items: "Naturalist Design / Strategic Projects / Ecosystemic Care / Los Cabos"
      },
      // Footer
      footer: {
        description: "Naturalist landscape firm. We design landscapes adapted to the microclimate, soil, and real use of each property.",
        liveOutside: "Live Outside",
        navigation: "Navigation",
        services: "Services",
        contact: "Contact",
        rights: "All rights reserved."
      },
      // Contact page
      contact: {
        subtitle: "Contact",
        title: "Let's talk about your project",
        description: "We start with an initial visit to get to know your property. The visit cost is deducted if you proceed with a project or maintenance plan.",
        visitaInicial: "Initial Visit",
        visitaDescription: "Includes property tour, preliminary analysis, and scope proposal.",
        descontable: "Deductible from project",
        form: {
          title: "Request information",
          name: "Full name",
          email: "Email",
          phone: "Phone",
          location: "Property location",
          serviceType: "Service type",
          propertyType: "Property type",
          message: "Message / Project details",
          submit: "Send message",
          sending: "Sending..."
        }
      },
      // Plans
      plans: {
        subtitle: "Plans & Pricing",
        title: "Choose your plan",
        description: "The initial visit cost is deducted if you proceed with a project or maintenance plan.",
        recommended: "Recommended",
        selectPlan: "Select plan",
        monthly: "monthly",
        unique: "one-time",
        howItWorks: "How does the model work?",
        modelDescription1: "We start with an Initial Visit to evaluate your property. This tour includes preliminary site analysis and scope proposal.",
        modelDescription2: "If you decide to proceed with a project or maintenance plan, the visit cost is deducted from the first payment.",
        plan1: {
          name: "Basic Maintenance",
          description: "Essential care for residential gardens"
        },
        plan2: {
          name: "Premium Maintenance",
          description: "Comprehensive care with technical advisory included"
        },
        plan3: {
          name: "Initial Visit",
          description: "Property evaluation — deductible from projects"
        }
      },
      // Blog
      blog: {
        subtitle: "Knowledge",
        title: "Blog",
        description: "Articles about landscaping, plant selection, and outdoor design in the Los Cabos climate.",
        readMore: "Read more"
      },
      // Servicios page
      serviciosPage: {
        subtitle: "Our Services",
        title: "Three technical service lines",
        description: "Each line responds to specific needs: from homeowners seeking long-term integration to developers prioritizing efficient execution.",
        requestInfo: "Request information",
        process: {
          title: "Círculo Process",
          description: "Our process ensures lasting results.",
          step1: { title: "Diagnosis", description: "Visit and site analysis" },
          step2: { title: "Design", description: "Naturalist master plan" },
          step3: { title: "Execution", description: "Phased implementation" },
          step4: { title: "Evolution", description: "Continuous follow-up" }
        },
        ctaTitle: "What do you need?",
        ctaDescription: "Start with an initial visit. The cost is deducted if you proceed to project or maintenance."
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
